import './sacalender.scss';
import moment from 'moment';
import { CircularProgress, Grid, InputLabel } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { SingelSelect } from '../../../../Core/FormInput';
import { GetTCardDashDropdowns, GetTCardCalendar } from '../../../../Core/Service/TCard-Calendar-service.js';
import ViewHoliday from './ViewHoliday.jsx';

const monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Month = ({ monthName, year, monthIndex, handleOpen, holidayList }) => {
    const daysInMonth = moment([year, monthIndex]).daysInMonth();
    const firstDay = moment([year, monthIndex, 1]).day();
    const adjustedFirstDay = firstDay === 0 ? 6 : firstDay - 1;
    const today = moment();
    const days = [];

    for (let i = 0; i < adjustedFirstDay; i++) {
        days.push(<div className="empty" key={`empty-${i}`}></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
        const isToday = today.isSame(moment([year, monthIndex, day]), 'day');
        const currentDay = moment([year, monthIndex, day]).day();
        const adjustedDay = currentDay === 0 ? 6 : currentDay - 1;

        let foundRecord = holidayList.find((k) => moment(k.date).format('YYYY-MM-DD') === moment([year, monthIndex, day]).format('YYYY-MM-DD'));
        let indexObject = foundRecord
            ? { ...foundRecord, isHoliday: foundRecord.isHoliday !== undefined ? foundRecord.isHoliday : true }
            : { isHoliday: false };

        const isWeekend = adjustedDay === 6;

        days.push(
            <Grid
                container
                alignContent="center"
                className="day"
                key={day}
                style={{
                    background: isWeekend ? '#9e1b32' : !indexObject.isHoliday && isToday ? '#009E60' : indexObject.isHoliday ? '#f2d4ce' : '#F4F4F5',
                    color: isWeekend || isToday ? 'white' : indexObject.isHoliday ? 'black' : 'black',
                    fontWeight: isToday ? 800 : 600
                }}
                onClick={() => handleOpen(moment([year, monthIndex, day]).format('YYYY-MM-DD'), indexObject)}
            >
                <Grid item>
                    {!indexObject.isHoliday ? (
                        day
                    ) : (
                        <abbr title={`${indexObject?.techOff} engineer${indexObject?.techOff > 1 ? 's' : ''} on holiday`} style={{ textDecoration: 'none' }}>
                            {day}
                        </abbr>
                    )}
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid item xs={12} sm md={6} lg={3} xl={3}>
            <div className="month">
                <div style={{ fontSize: 20, fontWeight: 700, padding: 5 }}>{monthName}</div>
                <div className="days-grid">
                    <div className="day-name">Mon</div>
                    <div className="day-name">Tue</div>
                    <div className="day-name">Wed</div>
                    <div className="day-name">Thu</div>
                    <div className="day-name">Fri</div>
                    <div className="day-name">Sat</div>
                    <div className="day-name">Sun</div>
                    {days}
                </div>
            </div>
        </Grid>
    );
};

export default function TCardHolidays() {
    const [state, setState] = useState({
        openModal: false,
        showEditModal: false,
        year: { id: moment().year(), name: moment().year().toString() },
        yearList: [],
        branch: [],
        branchID: {},
        holidayList: [],
        modalData: {},
        branchList: [],
        isHoliday: false,
        dropdownLoading: false,
        calendarLoading: false
    });

    useEffect(() => {
        if (state.branchList.length > 0) {
            const dashboardData = JSON.parse(localStorage.getItem('_dashboard_') || '{}');
            const selectedBranchName = dashboardData.BranchPartReq;
            const matchedBranch = state.branchList.find((b) => b.name === selectedBranchName);

            console.log(matchedBranch, 'matchedBranch');
            console.log(selectedBranchName, 'selectedBranchName');
            setState((st) => ({
                ...st,
                branchID: matchedBranch || state.branchList[0] || {}
            }));
        }
    }, [state.branchList]);

    const getLastFiveYears = () => {
        const years = [];
        const currentYear = 2025;
        for (let i = 0; i < 10; i++) {
            years.push(currentYear + i);
        }
        return years.map((val) => ({
            id: val,
            name: val.toString()
        }));
    };

    useEffect(() => {
        const fetchDropdownData = async () => {
            setState((st) => ({ ...st, dropdownLoading: true }));
            try {
                let dropdownRes = await GetTCardDashDropdowns();
                if (dropdownRes.success) {
                    const branches = dropdownRes?.data?.list;

                    setState((st) => ({
                        ...st,
                        branchList: dropdownRes.data?.branches || [],
                        branch: branches || [],
                        // branchID: matchedBranch || {},
                        yearList: getLastFiveYears(),
                        dropdownLoading: false
                    }));
                } else {
                    setState((st) => ({ ...st, dropdownLoading: false }));
                }
            } catch (error) {
                console.warn('Failed to fetch dropdown data', error);
                setState((st) => ({ ...st, dropdownLoading: false }));
            }
        };
        fetchDropdownData();
    }, []);

    useEffect(() => {
        (async () => {
            let res = await GetTCardDashDropdowns();
            if (res.success) {
                setState((st) => ({
                    ...st,
                    branchList: res.data?.branches || []
                }));
            }
        })();
    }, []);

    const pullData = useCallback(async () => {
        try {
            setState((st) => ({ ...st, calendarLoading: true }));
            let res = await GetTCardCalendar(state?.branchID?.id, state?.year?.id);
            if (res.success) {
                setState((st) => ({ ...st, holidayList: res.data || [], calendarLoading: false }));
            } else {
                setState((st) => ({ ...st, calendarLoading: false }));
            }
        } catch (error) {
            console.error('Error fetching calendar data:', error);
            setState((st) => ({ ...st, calendarLoading: false }));
        }
    }, [state?.branchID?.id, state?.year?.id]);

    useEffect(() => {
        if (state?.branchID?.id && state?.year?.id) {
            pullData();
        }
    }, [pullData, state?.branchID?.id, state?.year?.id]);

    const WorkCategoryChange = (nm) => (e, val) => {
        const branchName = val.name;

        const tempData = {
            ...JSON.parse(localStorage.getItem('_dashboard_') || '{}'),
            BranchBytime: branchName,
            selectedValueByTech: branchName,
            BranchPartReq: branchName,
            branchShortName: branchName
        };
        localStorage.setItem('_dashboard_', JSON.stringify(tempData));

        const btTimeData = {
            ...JSON.parse(localStorage.getItem('FiltterParams') || '{}'),
            branchShortName: branchName
        };
        localStorage.setItem('FiltterParams', JSON.stringify(btTimeData));
        setState((state) => ({
            ...state,
            [nm]: val
        }));
    };

    if (state.dropdownLoading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh' }}>
                <CircularProgress />
            </Grid>
        );
    }
    console.log(state, 'state');
    return (
        <div style={{ padding: 10 }}>
            <Grid container spacing={2} style={{ marginLeft: '-3px' }}>
                <Grid item xs={6} sm={6} md={3} xl={2} className="mandatory-fields">
                    <InputLabel required shrink>
                        Branch
                    </InputLabel>
                    <SingelSelect
                        isRequired
                        disabled={state.dropdownLoading}
                        style={{ marginRight: '6px' }}
                        options={state.branchList}
                        value={state.branchID}
                        onChange={WorkCategoryChange('branchID')}
                    />
                </Grid>
                <Grid item xs={6} sm={6} md={3} xl={2} style={{ marginLeft: '-3px' }} className="mandatory-fields">
                    <InputLabel required shrink>
                        Year
                    </InputLabel>
                    <SingelSelect
                        isRequired
                        disabled={state.dropdownLoading}
                        inputLabel="Year"
                        style={{ marginRight: '5px' }}
                        options={state.yearList}
                        value={state.year}
                        onChange={WorkCategoryChange('year')}
                    />
                </Grid>
            </Grid>

            {!(state?.branchID?.id && state?.year?.id) ? (
                <Grid container justifyContent="center">
                    <Grid>
                        <h3>{!state?.branchID?.id ? 'Please select a Branch' : 'Please select Year'}</h3>
                    </Grid>
                </Grid>
            ) : (
                <>
                    {state.calendarLoading ? (
                        <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
                            <CircularProgress />
                        </Grid>
                    ) : (
                        <Grid container spacing={1}>
                            <div className="calendar">
                                {monthList.map((month, index) => (
                                    <Month
                                        key={index}
                                        monthName={month}
                                        year={state.year.id}
                                        monthIndex={index}
                                        handleOpen={(date, data) => {
                                            const computedHoliday = data?.isHoliday === true || data?.isHoliday === 'true';
                                            setState((st) => ({
                                                ...st,
                                                selectedDate: date,
                                                modalData: data || {},
                                                showEditModal: true,
                                                isHoliday: computedHoliday
                                            }));
                                        }}
                                        holidayList={state.holidayList}
                                    />
                                ))}
                            </div>
                        </Grid>
                    )}
                </>
            )}

            {state.showEditModal ? (
                <ViewHoliday
                    selectedDate={state.selectedDate}
                    branchID={state.branchID.id}
                    isHoliday={state.isHoliday}
                    modalData={state.modalData}
                    onClose={(res) => {
                        setState((st) => ({ ...st, selectedDate: '', modalData: {}, showEditModal: false }));
                        res && pullData();
                    }}
                />
            ) : null}
        </div>
    );
}
